/** Funnel steps and conversion (D529). Counts are whatever the caller measures (people, orders, sessions). */
import { isFiniteNumber } from './numbers.js';
/** Steps with their conversion from the previous step and from the first. A missing value counts as 0. */
export function funnelSteps(inputs) {
    const values = inputs.map((s) => (isFiniteNumber(s.value) ? Math.max(0, s.value) : 0));
    const widest = Math.max(0, ...values);
    const first = values[0] ?? 0;
    const steps = inputs.map((s, i) => {
        const value = values[i] ?? 0;
        const prev = i === 0 ? null : (values[i - 1] ?? 0);
        return {
            key: s.key,
            label: s.label,
            value,
            fromPrevious: prev === null || prev === 0 ? null : value / prev,
            fromFirst: first === 0 ? null : value / first,
            dropOff: prev === null ? 0 : Math.max(0, prev - value),
            widthShare: widest === 0 ? 0 : value / widest,
        };
    });
    const last = steps[steps.length - 1];
    return { steps, overall: steps.length < 2 || first === 0 || last === undefined ? null : last.value / first };
}
//# sourceMappingURL=funnel.js.map